import { render, staticRenderFns } from "./wikiDown.vue?vue&type=template&id=83e43064"
import script from "./wikiDown.vue?vue&type=script&lang=js"
export * from "./wikiDown.vue?vue&type=script&lang=js"
import style0 from "./wikiDown.vue?vue&type=style&index=0&id=83e43064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports